import { useState } from "react";
import { NotificationManager } from "react-notifications";
import { api } from "api";
import { getErrorFromResponse } from "../../../../../../utility/utils";

export const FleteExternoApi = () => {
    const [cargando, setCargando] = useState(false);

    const actualizarFleteExterno = async (idFinca, data) => {
        try {
            setCargando(true);
            await api.post(`finca/${idFinca}/actualizar_flete_externo`, data);
            NotificationManager.success(
                "Precios de flete ajeno actualizados",
                "Éxito",
                3000,
            );
            return true;
        } catch (error) {
            const mensaje = getErrorFromResponse(
                error,
                "No se pudieron actualizar los precios de flete ajeno",
            );
            NotificationManager.error(mensaje, "ERROR", 5000);
            return false;
        } finally {
            setCargando(false);
        }
    };

    return { actualizarFleteExterno, cargando };
};
